module.exports = __webpack_public_path__ + "static/media/girl_washing_dish.c160b8a5.gif";